import styled from "styled-components";

export const Container = styled.div`
  ul {
    display: flex;
    flex-wrap: nowrap;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    + li {
      margin-left: 15px;
    }
  }
`;
